import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FirmaObj } from 'src/app/models/firma-obj';
import {
  MovimentoArticolo,
  MovimentoArticoloModel,
  NewMovimentoArticoloResponse,
} from 'src/app/models/movimento-articolo';
import { environment } from '../../../environments/environment';
import { TabellaStatisticheModel } from 'src/app/models/tabella-statistiche';
@Injectable({
  providedIn: 'root',
})
export class MovimentoArticoliService {
  private http = inject(HttpClient);

  movArticoloUrl = environment.ildatoArticoliDpi + 'api/movimentidpi';

  private movimentiArticoliSubject = new BehaviorSubject<MovimentoArticolo[] | undefined>(undefined);

  list(
    idDipendente: number = 0,
    idArticolo: number = 0,
  ): Observable<MovimentoArticolo[]> {
    let filter = '';
    if (idDipendente != null && idDipendente > 0) {
      filter += 'IdDipendente=' + idDipendente + '&';
    }

    if (idArticolo != null && idArticolo > 0) {
      filter += 'IdArticolo=' + idArticolo + '&';
    }

    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }
    return this.http.get<MovimentoArticolo[]>(this.movArticoloUrl + filter);
  }

  get(idMov: number): Observable<MovimentoArticolo> {
    return this.http.get<MovimentoArticolo>(this.movArticoloUrl + '/' + idMov);
  }

  getByProgr(progrMov: number): Observable<MovimentoArticoloModel> {
    return this.http.get<MovimentoArticoloModel>(
      this.movArticoloUrl + '/byprogr/' + progrMov,
    );
  }

  insert(
    values: MovimentoArticoloModel,
  ): Observable<NewMovimentoArticoloResponse> {
    console.log(values);
    return this.http.post<NewMovimentoArticoloResponse>(
      this.movArticoloUrl,
      values,
    );
  }

  insertGiornaliera(
    values: MovimentoArticoloModel,
  ): Observable<NewMovimentoArticoloResponse> {
    return this.http.post<NewMovimentoArticoloResponse>(
      this.movArticoloUrl + '/insertgiornaliera',
      values,
    );
  }

  remove(idArticolo: number): Observable<MovimentoArticolo> {
    console.log(idArticolo);
    return this.http.delete<MovimentoArticolo>(
      this.movArticoloUrl + '/' + idArticolo,
    );
  }

  update(
    key: number,
    values: MovimentoArticolo,
  ): Observable<MovimentoArticolo> {
    console.log(values);
    return this.http.put<MovimentoArticolo>(
      this.movArticoloUrl + '/' + key,
      values,
    );
  }

  generaDatiTabellaStatistiche(
    idArticolo: number,
    daData: Date,
    aData: Date,
  ): Observable<TabellaStatisticheModel> {
    return this.http.get<TabellaStatisticheModel>(
      this.movArticoloUrl +
        '/generaDatiTabella/' +
        idArticolo +
        '/' +
        daData.toJSON() +
        '/' +
        aData.toJSON(),
    );
  }

  allega(
    progrMov: number,
    nome: string,
    data: FormData,
  ): Observable<MovimentoArticoloModel> {
    return this.http.put<MovimentoArticoloModel>(
      this.movArticoloUrl + '/allega/' + progrMov + '/' + nome,
      data,
    );
  }

  scaricaByProgr(progrMov: number): Observable<Blob> {
    return this.http.get(
      this.movArticoloUrl + '/getallegato?progr=' + progrMov,
      { responseType: 'blob' },
    );
  }

  daFirmareByProgr(
    progrMov: number,
    consegnaGiornaliera?: boolean,
  ): Observable<Blob> {
    return this.http.get<Blob>(
      this.movArticoloUrl +
        '/getFileDaFirmare?progr=' +
        progrMov + ( consegnaGiornaliera != undefined ? '&ConsegnaGiornaliera=' + consegnaGiornaliera : ''),
      { responseType: 'blob' as 'json' },
    );
  }

  daFirmareCartaceaByProgr(
    progrMov: number,
    consegnaGiornaliera?: boolean,
  ): Observable<Blob> {
    return this.http.get(
      this.movArticoloUrl +
        '/getFileDaFirmareCartacea?progr=' +
        progrMov + ( consegnaGiornaliera != undefined ? '&ConsegnaGiornaliera=' + consegnaGiornaliera : ''),
      { responseType: 'blob' },
    );
  }

  firmaMovimento(
    progrMov: number,
    firmaObj: FirmaObj,
    consegnaGiornaliera?: boolean,
  ): Observable<any> {
    return this.http.post(
      this.movArticoloUrl +
        '/firma/' +
        progrMov + ( consegnaGiornaliera != undefined ? '?ConsegnaGiornaliera=' + consegnaGiornaliera : ''),
      firmaObj,
      { responseType: 'blob' },
    );
  }

  allegaFileFirmato(
    progrMov: number,
    inviaMail: boolean,
    data: FormData,
    consegnaGiornaliera?: boolean,
  ): Observable<any> {
    return this.http.post(
      this.movArticoloUrl +
        '/allegaFileFirmato/' +
        progrMov +
        '/' +
        inviaMail + ( consegnaGiornaliera != undefined ? '?ConsegnaGiornaliera=' + consegnaGiornaliera : ''),
      data,
    );
  }

  stampaListaByDip(idDipendente: number): Observable<Blob> {
    return this.http.get(
      this.movArticoloUrl + '/stampaElencoPerDipendente/' + idDipendente,
      { responseType: 'blob' },
    );
  }

  stampaListaByDipDate(
    idDipendente: number,
    daData: Date,
    aData: Date,
  ): Observable<Blob> {
    const daDataStr = daData.toJSON();
    const aDataStr = aData.toJSON();
    return this.http.get(
      this.movArticoloUrl +
        '/stampaElencoPerDipendente/' +
        idDipendente +
        '/' +
        daDataStr +
        '/' +
        aDataStr,
      { responseType: 'blob' },
    );
  }

  stampaListaByMovs(idDipendente: number, selection: any): Observable<Blob> {
    return this.http.post(
      this.movArticoloUrl +
        '/stampaElencoPerDipendente/selection/' +
        idDipendente,
      selection,
      { responseType: 'blob' },
    );
  }

  scarica(id: number): Observable<Blob> {
    return this.http.get(this.movArticoloUrl + '/getallegato?id=' + id, {
      responseType: 'blob',
    });
  }

  esportaArchivio(
    idDipendente: number,
    selection: any,
    daData: Date,
    aData: Date,
  ): Observable<Blob> {
    let filter = '';
    if (idDipendente != null && idDipendente > 0) {
      filter += 'IdDipendente=' + idDipendente + '&';
    }
    if (daData != null) {
      filter += 'DaData=' + daData.toJSON() + '&';
    }
    if (aData != null) {
      filter += 'AData=' + aData.toJSON() + '&';
    }

    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }

    return this.http.post(
      this.movArticoloUrl + '/esportaArchivio/' + filter,
      selection,
      { responseType: 'blob' },
    );
  }

  esportaDocumenti(
    idDipendente: number,
    selection: any,
    daData: Date,
    aData: Date,
  ): Observable<Blob> {
    let filter = '';
    if (idDipendente != null && idDipendente > 0) {
      filter += 'IdDipendente=' + idDipendente + '&';
    }
    if (daData != null) {
      filter += 'DaData=' + daData.toJSON() + '&';
    }
    if (aData != null) {
      filter += 'AData=' + aData.toJSON() + '&';
    }

    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }

    return this.http.post(
      this.movArticoloUrl + '/esportaDocumenti' + filter,
      selection,
      { responseType: 'blob' },
    );
  }

  get listMovimentiArticoli(): BehaviorSubject<MovimentoArticolo[]> {
    if (
      this.movimentiArticoliSubject == undefined ||
      this.movimentiArticoliSubject.value == undefined ||
      this.movimentiArticoliSubject.value.length == 0
    ) {
      this.updateCurrentListMovimentiArticoli();
    }
    return this.movimentiArticoliSubject;
  }

  updateCurrentListMovimentiArticoli() {
    this.list().subscribe((dati) => {
      this.movimentiArticoliSubject.next(dati);
    });
  }

  filtered(
    idArticolo = 0,
    idDipendente = 0,
    progr = 0,
    daData: Date | null = null,
    aData: Date | null = null,
    firmato: boolean | null = null,
  ): Observable<MovimentoArticolo[]> {
    let filter = '';
    if (idArticolo != null && idArticolo > 0) {
      filter += 'IdArticolo=' + idArticolo + '&';
    }
    if (idDipendente != null && idDipendente > 0) {
      filter += 'IdDipendente=' + idDipendente + '&';
    }
    if (progr != null && progr > 0) {
      filter += 'Progr=' + progr + '&';
    }
    if (daData != null) {
      filter += 'DaData=' + daData.toJSON() + '&';
    }
    if (aData != null) {
      filter += 'AData=' + aData.toJSON() + '&';
    }
    if (firmato != null) {
      filter += 'Firmato=' + firmato + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }
    return this.http.get<MovimentoArticolo[]>(
      this.movArticoloUrl + '/filtered' + filter,
    );
  }

  listConsegne(
    idDipendente: number | null,
    idArticolo: number | null,
  ): Observable<any[]> {
    let filter = '';
    if (idArticolo != null && idArticolo > 0) {
      filter += 'IdArticolo=' + idArticolo + '&';
    }
    if (idDipendente != null && idDipendente > 0) {
      filter += 'IdDipendente=' + idDipendente + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }
    return this.http.get<any[]>(this.movArticoloUrl + '/listConsegne' + filter);
  }

  datiGraficiTipologie(idDipendente: number | null): Observable<any[]> {
    let filter = '';
    if (idDipendente != null && idDipendente > 0) {
      filter += 'IdDipendente=' + idDipendente + '&';
    }

    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }
    return this.http.get<any[]>(
      this.movArticoloUrl + '/datiGraficiTipologie/' + filter,
    );
  }

  cleanTemp(){
    this.movimentiArticoliSubject.next(undefined);
  }
}
